import { ProcessedErrors } from './errorHandler';

export interface ApiResult<T = unknown> {
  success: boolean;
  data?: T;
  errors?: ProcessedErrors;
}

export const createApiError = (message: string): ProcessedErrors => ({
  fieldErrors: {},
  nonFieldErrors: [],
  generalError: message,
});

export const handleApiResult = async <T>(
  response: Response,
  _errorMessage: string
): Promise<ApiResult<T>> => {
  if (response.ok) {
    const contentType = response.headers.get('content-type');
    const contentLength = response.headers.get('content-length');

    if (
      response.status === 204 ||
      contentLength === '0' ||
      !contentType?.includes('application/json')
    ) {
      return { success: true };
    }

    try {
      const text = await response.text();
      if (!text || text.trim() === '') {
        return { success: true };
      }
      const data = JSON.parse(text) as T;
      return { success: true, data };
    } catch (parseError) {
      return { success: true };
    }
  } else {
    const { handleApiError } = await import('./errorHandler');
    const processedErrors = await handleApiError(response);
    return { success: false, errors: processedErrors };
  }
};

export const handleApiCatch = (error: unknown, defaultMessage: string): ProcessedErrors => {
  return createApiError(error instanceof Error ? error.message : defaultMessage);
};
